import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

const CoverageIcon = () => (
  <SvgIcon width="32" height="32" viewBox="0 0 32 32">
    {/* Shield with percentage/coverage indicator */}
    <path
      d="M16 4L7 8V15C7 21 11 26 16 28C21 26 25 21 25 15V8L16 4Z"
      fill="#17E88F"
    />
    <path d="M16 4L7 8V15C7 21 11 26 16 28V4Z" fill="#0FB870" />

    {/* Checkmark */}
    <path
      d="M12 16L15 19L21 13"
      stroke="white"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />

    {/* Coverage arc */}
    <path
      d="M16 6C11 6 8 9 8 14C8 19 11 23 16 26"
      stroke="#0D9359"
      strokeWidth="1.5"
      fill="none"
      opacity="0.5"
    />
  </SvgIcon>
);

export default CoverageIcon;
